var stem = function (val, dosearch){
	
	if(!val || val.length < 1 ) {
		return;
	}
	
	//L10n Config
	var regxObj = {
		"en":{
			"typeRegx" :
		"\\b(\\*|everything|anything|data|features|web[ ]?scene|3d|globe|imagery|images|image|mobile|city[ ]?engine|jpeg|jpg|ppt[x]?|shp|csv|kml|kmz|code|zip|shp|shapefile|lyr|layers|templates|document[s]?|webapp[s]?|app[s]?|webmap[s]?|presentation[s]?|basemap[s]?|map[s]?|mapservice[s]?|feature[ ]?service[s]?|service[s]?|tiles|tpk|pdf|doc|docx|wms|ogc|sd|mxd)\\b",
		
		"tagRegx" : "#[a-zA-Z0-9_-]+",
		"popular" : "\\b(popular)\\b",
		"oldest" : "\\b(oldest)\\b",
		
		"intentTimeRegx": "\\b(last month|last year|year|week|month|today|yesterday|latest)\\b",
		"inmeta": "\\sin\\s",
		"at": "\\sat\\s"
		},
		
		"zh":{
			"typeRegx" : 	"(数据|特征|要素|3维|三维|三d|地球|影像|图像|图片|手机|移动|城市引擎|幻灯片|代码|压缩包|压缩文件|图层|模板|文本|文档|软件|网页|网页软件|网络地图|网页地图|展示|底图|地图|地图服务|特征服务|要素服务|服务|图块|地图图块|图块包|地图图块包)[数据]?",
		
		"tagRegx" : "#\W+",
		"popular" : "最受欢迎[的]?",
		"oldest" : "最老[的]?",
		
		"intentTimeRegx": "(上个月|去年|年|周|月|今天|昨天|最近的)",
		"inmeta": "在.+的",
		"at": "\\sat\\s"
		}
	}
	
		
	original_query = val;
	var wordlist,
		ix,
		error_messages = [],		
		stem,
		overlap = [],
		stemmed = [],
		stopped = [],
		test = val;
		
		results = [],
		cleaned_results = [],
		intent_location = null,
		intent_keywords = null,		
		intent_user = null,
		intent_tags = null,
		negative_tags = null,
		intent_duration = null,
		intent_timerange = null,
		intent_sort = "",
    intent_sortField = "",
      //intent_sortField = "modified",
   //intent_sortField = "relevance",
   //intent_sortField = "",

		negative_intent_keywords = null,
		intent_type = null,
		intent_extent = null,
		tag_search = [],
		l10n = false;

		lang = "en",
		stopwords_tags = cleanupObj[lang].stopwords_tags,
		stopwords_time = cleanupObj[lang].stopwords_time,
		stopwords_geo = cleanupObj[lang].stopwords_geo,
		stopwords_dict = cleanupObj[lang].stopwords_dict,
		searchKeywords =  cleanupObj[lang].searchKeywords;
		
		if(lang != "en"){
			l10n = true;
		}



	//get usernames first since its case sensitive
	if(test.match(/@[a-zA-Z0-9_-]+/)) {
		intent_user = test.match(/@[a-zA-Z0-9_-]+/g)[0];
		test = test.replace(intent_user,"");
		intent_user = intent_user.replace("@","");
	} else if (test.match(/\b(by esri|from esri)\b/gi)) {
		intent_user = test.match(/\b(by esri|from esri)\b/gi)[0];
		test = test.replace(intent_user,"");
		intent_user = "(esri OR AtlasPublisher OR esri_atlas esri_en OR Esri_content OR EsriMedia OR StoryMaps)";
	}

	test = test.toLowerCase().trim();
	error_messages.push("Lower case Input: " + test);

	//remove commonly used special characters
	test = test.replace(/|&|\.|;|!|\?|\(|\)|"|'|'$/g,'');
	error_messages.push("After Special Chars: " + test);
	
	// dump non-words
	//test = test.replace(/[^\w]/g, ' ');
	//error_messages.push("Non-words: " + test);

	// dump multiple white-space
	test = test.replace(/\s+/g, ' ');
	error_messages.push("Whitespace: " + test);	

	//  if it's only numbers, remove it
    var digits_match = test.match(/\d/g);
    if(digits_match && digits_match.length === test.length) {
    	test = "";
    }

	error_messages.push("After Digits Match: " + test);	

	if(test.length > 0) {	

		switch (l10n) {
        // English (default)
        default: var type = test.match(/\b(\*|everything|anything|data|features|web[ ]?scene|3d|globe|imagery|images|image|mobile|city[ ]?engine|jpeg|jpg|ppt[x]?|shp|csv|kml|kmz|code|zip|shp|shapefile|lyr|layers|templates|document[s]?|webapp[s]?|app[s]?|webmap[s]?|presentation[s]?|basemap[s]?|map[s]?|mapservice[s]?|feature[ ]?service[s]?|service[s]?|tiles|tpk|pdf|doc|docx|wms|ogc|sd|mxd)\b/g) || "";
        switch (type.toString().replace(" ", "")) {
          //Maps      
          case "map":
          case "maps":
          case "webmap":
          case "webmaps":
            intent_type = "Web Map";
            intent_keywords = "Web Map,Online Map,Map,ArcGIS Online";
            negative_intent_keywords = "web mapping application";
            negative_tags = "basemap";
            break;
          case "basemap":
          case "basemaps":
            intent_type = "Map Service, tiles";
            break;
          case "presentation":
          case "presentations":
            intent_keywords = "Presentation Map";
            intent_type = "Web Map";
            break;

            //Apps
          case "webapp":
          case "webapps":
          case "app":
          case "apps":
            intent_type = "Web Mapping Application,Application,Mobile Application,Code Sample";
            break;
          case "mobile":
            intent_type = "Mobile Application";
            break;
          case "code":
            intent_type = "Code Sample";
            break;
          case "cityengine":
          case "webscene":
          case "3d":
          case "globe":
            intent_type = "CityEngine Web Scene,Globe Service";
            break;
          case "templates":
            intent_type = "Web Mapping Application,Map Template,Feature Collection Template,Desktop Application Template";
            break;

            //Layers
          case "tpk":
            intent_type = "Tile package";
            break;
          case "lyr":
          case "layer":
            intent_type = "Layer, Layer Package";
            break;
          case "shp":
            intent_type = "Shapefile";
            break;
          case "csv":
            intent_type = "CSV";
            break;
          case "kml":
          case "kmz":
            intent_type = "KML";
            intent_keywords = "kml,kmz,Map,Data";
            break;
          case "sd":
            intent_type = "Service Definition";
            break;
          case "fgdb":
            intent_type = "File Geodatabase";
            break;
          case "wms":
          case "ogc":
            intent_type = "WMS";
            intent_keywords = "OGC";
            break;
          case "tiles":
            intent_keywords = "Hosted";
            intent_type = "Map Service";
            break;
          case "data":
            intent_type = "Feature Collection,KML,CSV,Shapefile,Feature Service";
            intent_keywords = "Data";
            break;

            //Documents
          case "jpg":
          case "jpeg":
          case "images":
          case "image":
            intent_type = "Image";
            break;
          case "doc":
          case "docx":
            intent_type = "Microsoft Word";
            intent_keywords = "Document";
            break;
          case "ppt":
          case "pptx":
            intent_type = "Microsoft Powerpoint";
            intent_keywords = "Document";
            break;
          case "pdf":
            intent_type = "PDF";
            intent_keywords = "Document";
            break;
          case "document":
          case "documents":
            intent_keywords = "Document";
            break;
          case "mxd":
            intent_type = "Map Document";
            intent_keywords = "Document";
            break;

            //Data
          case "shapefile":
          case "shp":
            intent_type = "Shapefile";
            break;

            //Services
          case "mapservice":
          case "mapservices":
            intent_type = "Map Service";
            break;
          case "features":
            intent_type = "Feature Collection,Feature Service,Shapefile";
            break;
          case "featureservice":
          case "featureservices":
            intent_keywords = "service";
            intent_type = "Feature Service";
            break;
          case "service":
          case "services":
            intent_keywords = "service";
            intent_type = "Map Service,Image Service,Feature Service";
            break;
          case "imagery":
            intent_keywords = "service";
            intent_type = "Image Service";
            break;

            //Anything
          case "*":
          case "anything":
          case "everything":
            intent_type = "Web Map,Web Mapping Application,Map Service, Image Service, Feature Service, KML, CSV, Shapefile, Code Sample";
            intent_keywords = "Document, Online Map, Web Map, Data, Hosted";
            intent_sort = "desc";
            negative_tags = "basemap";
            break;

          default:
            intent_type = "Web Map,Web Mapping Application,Feature Service,Map Service,Image Service,Code Sample,CityEngine Web Scene";
            intent_keywords = "Online Map,Data";
            intent_sort = "desc";
            negative_tags = "basemap";
            break;
        }
        break;
        
		  // l10n
        case true:
            var re = new RegExp(regxObj[lang].typeRegx, 'g')
				var type = test.match(/\b(\*|everything|anything|data|features|web[ ]?scene|3d|globe|imagery|images|image|mobile|city[ ]?engine|jpeg|jpg|ppt[x]?|shp|csv|kml|kmz|code|zip|shp|shapefile|lyr|layers|templates|document[s]?|webapp[s]?|app[s]?|webmap[s]?|presentation[s]?|basemap[s]?|map[s]?|mapservice[s]?|feature[ ]?service[s]?|service[s]?|tiles|tpk|pdf|doc|docx|wms|ogc|sd|mxd)\b/g) || test.match(re) || "";
          switch (type.toString().replace(" ", "").replace("数据", "")) {
            //Maps
            case "map":
            case "maps":
            case "webmap":
            case "webmaps":
            case searchKeywords['maps']:
            case searchKeywords['webmap']:
            case searchKeywords['webmaps']:
              intent_type = "Web Map";
              intent_keywords = "Web Map,Online Map,Map,ArcGIS Online";
              negative_intent_keywords = "web mapping application";
              negative_tags = "basemap";
              break;
            case "basemap":
            case "basemaps":
            case searchKeywords['basemaps']:
              intent_type = "Map Service, tiles";
              break;
            case "presentation":
            case "presentations":
            case searchKeywords['presentations']:
              intent_keywords = "Presentation Map";
              intent_type = "Web Map";
              break;

              //Apps
            case "webapp":
            case "webapps":
            case "app":
            case "apps":
            case searchKeywords['app']:
            case searchKeywords['apps']:
              intent_type = "Web Mapping Application,Application,Mobile Application,Code Sample";
              break;
            case "mobile":
            case "手机":
            case "移动":
              intent_type = "Mobile Application";
              break;
            case "code":
            case "代码":
              intent_type = "Code Sample";
              break;
            case "cityengine":
            case "webscene":
            case "3d":
            case "globe":
            case searchKeywords['cityengine']:
            case searchKeywords['webscene']:
            case searchKeywords['3d']:
            case searchKeywords['globe']:
              intent_type = "CityEngine Web Scene,Globe Service";
              break;
            case "templates":
            case searchKeywords['templates']:
              intent_type = "Web Mapping Application,Map Template,Feature Collection Template,Desktop Application Template";
              break;

              //Layers
            case "tpk":
            case searchKeywords['tpk']:
              intent_type = "Tile package";
              break;
            case "lyr":
            case "layer":
            case searchKeywords['layer']:
              intent_type = "Layer, Layer Package";
              break;
            case "shp":
              intent_type = "Shapefile";
              break;
            case "csv":
              intent_type = "CSV";
              break;
            case "kml":
            case "kmz":
              intent_type = "KML";
              intent_keywords = "kml,kmz,Map,Data";
              break;
            case "sd":
              intent_type = "Service Definition";
              break;
            case "fgdb":
              intent_type = "File Geodatabase";
              break;
            case "wms":
            case "ogc":
              intent_type = "WMS";
              intent_keywords = "OGC";
              break;
            case "tiles":
            case searchKeywords['tiles']:
            case searchKeywords['tiles']:
              intent_keywords = "Hosted";
              intent_type = "Map Service";
              break;
            case "data":
            case searchKeywords['data']:
              intent_type = "Feature Collection,KML,CSV,Shapefile,Feature Service";
              intent_keywords = "Data";
              break;

              //Documents
            case "jpg":
            case "jpeg":
            case "images":
            case "image":
            case searchKeywords['image']:
            case searchKeywords['images']:
              intent_type = "Image";
              break;
            case "doc":
            case "docx":
              intent_type = "Microsoft Word";
              intent_keywords = "Document";
              break;
            case "ppt":
            case "pptx":
            case "幻灯片":
              intent_type = "Microsoft Powerpoint";
              intent_keywords = "Document";
              break;
            case "pdf":
              intent_type = "PDF";
              intent_keywords = "Document";
              break;
            case "document":
            case "documents":
            case searchKeywords['document']:
            case searchKeywords['documents']:
              intent_keywords = "Document";
              break;
            case "mxd":
              intent_type = "Map Document";
              intent_keywords = "Document";
              break;

              //Data
            case "shapefile":
            case "shp":
              intent_type = "Shapefile";
              break;

              //Services
            case "mapservice":
            case "mapservices":
            case searchKeywords['mapservices']:
              intent_type = "Map Service";
              break;
            case "features":
            case searchKeywords['feature']:
            case searchKeywords['features']:
              intent_type = "Feature Collection,Feature Service,Shapefile";
              break;
            case "featureservice":
            case "featureservices":
            case searchKeywords['featureservice']:
            case searchKeywords['featureservices']:
              intent_keywords = "service";
              intent_type = "Feature Service";
              break;
            case "service":
            case "services":
            case searchKeywords['services']:
              intent_keywords = "service";
              intent_type = "Map Service,Image Service,Feature Service";
              break;
            case "imagery":
            case searchKeywords['imagery']:
              intent_keywords = "service";
              intent_type = "Image Service";
              break;

              //Anything
            case "*":
            case "anything":
            case "everything":
              intent_type = "Web Map,Web Mapping Application,Map Service, Image Service, Feature Service, KML, CSV, Shapefile, Code Sample";
              intent_keywords = "Document, Online Map, Web Map, Data, Hosted";
              intent_sort = "desc";
              negative_tags = "basemap";
              break;

            default:
              intent_type = "Web Map,Web Mapping Application,Feature Service,Map Service,Image Service,Code Sample,CityEngine Web Scene";
              intent_keywords = "Online Map,Data";
              intent_sort = "desc";
              negative_tags = "basemap";
              break;
          }
      }
				
	
		var re = new RegExp(regxObj[lang].tagRegx, 'gi')
		if(test.match(re)) {
			var arr_tags = (lang == "zh")?test.match(re)[0].split(" "):test.match(re);
			for(var i=0; i< arr_tags.length; i++) {
				test = test.replace(arr_tags[i],"");
				arr_tags[i] = arr_tags[i].replace("#","").replace("_"," ");
			}
			intent_tags = arr_tags.join(", ");
		}
		/* if (lang == "zh" && test.match(/#\W+/g)) {
        var arr_tags = test.match(/#\W+/g)[0].split(" ");
        for (var i = 0; i < arr_tags.length; i++) {
          if (arr_tags[i].match(/#\W+/)) {
            test = test.replace(arr_tags[i], "");
            arr_tags[i] = arr_tags[i].replace("#", "").replace("_", " ");
          }
        }
        intent_tags = arr_tags.join(", ");
      }*/

		 re = new RegExp(regxObj[lang].popular, 'gi')
		 if (test.match(re)) {
        test = test.replace(searchKeywords['popular'], "");
        intent_sort = "desc";
        intent_sortField = "views";
      }

      re = new RegExp(regxObj[lang].oldest, 'gi')
		if (test.match(re)) {
        test = test.replace(searchKeywords['oldest'], "");
        intent_duration = "oldest";
        intent_sort = "asc";
        intent_sortField = "modified";
      }

		 switch (l10n) {
        default: if (test.match(/\b(last month|last year|year|week|month|today|yesterday|latest)\b/g)) {
            var temp_time_intent_arr = test.match(/\b(last month|last year|year|week|month|today|yesterday|latest)\b/g);
            for (var ii = 0; ii < temp_time_intent_arr.length; ii++) {
              var temp_time_intent = temp_time_intent_arr[ii];

              var to_date, from_date;
              var curr_date = new Date(),
                curr_year = curr_date.getFullYear(),
                curr_month = curr_date.getMonth(),
                curr_day = curr_date.getDate();

              switch (temp_time_intent) {
                case "last year":
                  intent_duration = "last year";
                  intent_sort = "asc";
                  from_date = new Date(curr_year - 1, 0, 1);
                  to_date = new Date(curr_year - 1, 11, 31, 23, 59, 59);
                  break;
                case "last month":
                  intent_duration = "last month";
                  intent_sort = "asc";
                  from_date = new Date(curr_year, curr_month - 1);
                  to_date = new Date(curr_year, curr_month, 1, 0, 0, 0);
                  break;
                case "week":
                  intent_duration = "week ago";
                  intent_sort = "asc";
                  from_date = new Date(curr_date.getTime() - 7 * 24 * 60 * 60 * 1000);
                  to_date = new Date();
                  break;
                case "month":
                  intent_duration = "month";
                  intent_sort = "asc";
                  from_date = new Date(curr_year, curr_month, 1);
                  to_date = new Date();
                  break;
                case "year":
                  intent_duration = "year";
                  intent_sort = "asc";
                  from_date = new Date(curr_year, 0, 1);
                  to_date = new Date();
                  break;
                case "today":
                  intent_duration = "today";
                  intent_sort = "desc";
                  from_date = new Date(curr_year, curr_month, curr_day);
                  to_date = new Date(curr_year, curr_month, curr_day, 23, 59, 59);
                  break;
                case "latest":
                  intent_duration = "latest (last week)";
                  intent_sort = "desc";
                  from_date = new Date(curr_date.getTime() - 7 * 24 * 60 * 60 * 1000);
                  to_date = new Date();
                  break;
                case "yesterday":
                  intent_duration = "yesterday";
                  intent_sort = "asc";
                  from_date = new Date(curr_year, curr_month, curr_day - 1);
                  to_date = new Date(curr_year, curr_month, curr_day - 1, 23, 59, 59);
                  break;
                default:
                  break;
              }
              if (intent_duration) test = test.replace(intent_duration, "");
            }

            if (to_date && from_date) {
              intent_timerange = "[" + pad(from_date.getTime(), 19) + " TO " + pad(to_date.getTime(), 19) + "]";
            }
          }

        break;

       
		  case true:
				re = new RegExp(regxObj[lang].intentTimeRegx, 'g')
            if (test.match(/\b(last month|last year|year|week|month|today|yesterday|latest)\b/g) || test.match(re)) {
              var temp_time_intent_arr = test.match(/\b(last month|last year|year|week|month|today|yesterday|latest)\b/g) || test.match(re);
              for (var ii = 0; ii < temp_time_intent_arr.length; ii++) {
                var temp_time_intent = temp_time_intent_arr[ii];

                var to_date, from_date;
                var curr_date = new Date(),
                  curr_year = curr_date.getFullYear(),
                  curr_month = curr_date.getMonth(),
                  curr_day = curr_date.getDate();

                switch (temp_time_intent) {
                  case "last year":
                  case searchKeywords['lastyear']:
                    intent_duration = "last year";
                    intent_sort = "asc";
                    from_date = new Date(curr_year - 1, 0, 1);
                    to_date = new Date(curr_year - 1, 11, 31, 23, 59, 59);
                    break;
                  case "last month":
                  case searchKeywords['lastmonth']:
                    intent_duration = "last month";
                    intent_sort = "asc";
                    from_date = new Date(curr_year, curr_month - 1);
                    to_date = new Date(curr_year, curr_month, 1, 0, 0, 0);
                    break;
                  case "week":
                  case searchKeywords['week']:
                    intent_duration = "week ago";
                    intent_sort = "asc";
                    from_date = new Date(curr_date.getTime() - 7 * 24 * 60 * 60 * 1000);
                    to_date = new Date();
                    break;
                  case "month":
                  case searchKeywords['month']:
                    intent_duration = "month";
                    intent_sort = "asc";
                    from_date = new Date(curr_year, curr_month, 1);
                    to_date = new Date();
                    break;
                  case "year":
                  case searchKeywords['year']:
                    intent_duration = "year";
                    intent_durationZH = searchKeywords['year'];
                    intent_sort = "asc";
                    from_date = new Date(curr_year, 0, 1);
                    to_date = new Date();
                    break;
                  case "today":
                  case searchKeywords['today']:
                    intent_duration = "today";
                    intent_sort = "desc";
                    from_date = new Date(curr_year, curr_month, curr_day);
                    to_date = new Date(curr_year, curr_month, curr_day, 23, 59, 59);
                    break;
                  case "latest":
                  case searchKeywords['latest']:
                    intent_duration = "latest (last week)";
                    intent_sort = "desc";
                    from_date = new Date(curr_date.getTime() - 7 * 24 * 60 * 60 * 1000);
                    to_date = new Date();
                    break;
                  case "yesterday":
                  case searchKeywords['yesterday']:
                    intent_duration = "yesterday";
                    intent_sort = "asc";
                    from_date = new Date(curr_year, curr_month, curr_day - 1);
                    to_date = new Date(curr_year, curr_month, curr_day - 1, 23, 59, 59);
                    break;
                  default:
                    break;
                }
                if (intent_duration) {
                  test = test.replace(intent_duration, "");
                }
              }

              if (to_date && from_date) {
                intent_timerange = "[" + pad(from_date.getTime(), 19) + " TO " + pad(to_date.getTime(), 19) + "]";
              }
            }
				
				 re = new RegExp(regxObj[lang].inmeta, 'g')
				 if (test.match(re)) {
					intent_location = test.match(re)[0].replace(searchKeywords['in'], "").replace(searchKeywords['at'], "");
					test = test.replace(test.match(re)[0], "");
				 }
          break;

      }
		
		 if (test.match(/\sin\s/)) {
          if (test.split(/\sin\s/).length > 1) {
            var in_arr = test.split(/\sin\s/);
            test = in_arr.slice(0, 1).join();
            intent_location = in_arr.slice(1, in_arr.length).join(" ");
          }
        }

        if (test.match(/\sat\s/)) {
          if (test.split(/\sat\s/).length > 1) {
            var in_arr = test.split(/\sat\s/);
            test = in_arr.slice(0, 1).join();
            intent_location = in_arr.slice(1, in_arr.length).join(" ");
          }
        }

		
		// split
		wordlist = test.split(/\s/);
		error_messages.push("Wordlist: " + wordlist.join(" | "));

		if (intent_location) {
        var intent_location_wordlist = intent_location.split(" ");
        var new_intent_location_arr = [];

        switch (lang) {
          //default: for (il in intent_location_wordlist) {
          default: for (var il=0 ; li<intent_location_wordlist.length ; li++) {
            if (stopwords_dict.indexOf(intent_location_wordlist[il]) < 0 && stopwords_geo.indexOf(intent_location_wordlist[il]) < 0) {
              new_intent_location_arr.push(intent_location_wordlist[il]);
            }
          }
          break;

        }

        intent_location = new_intent_location_arr.join(" ");
        //tag_search = tag_search.concat(new_intent_location_arr);            
        if (new_intent_location_arr.length > 1) {
          tag_search.push(new_intent_location_arr[0]);
          tag_search.push(new_intent_location_arr[1]);
        } else {
          tag_search.push(new_intent_location_arr[0]);
        }
        //sathya - needed to search for locations
        //test += " " + new_intent_location_arr.join(" ");
      }
		
	   	
			
		switch (lang) {
        default: for(ix = 0; ix < wordlist.length; ix++) {
			  
          if (stopwords_dict.indexOf(wordlist[ix]) < 0 && stopwords_geo.indexOf(wordlist[ix]) < 0) {

            if (stopwords_tags.indexOf(wordlist[ix]) < 0) {
              tag_search.push(wordlist[ix]);
            }
            cleaned_results.push(wordlist[ix]);
            stem = stemmer(wordlist[ix]);
            overlap.push(wordlist[ix].replace(stem, stem + '<b><u>') + '</u></b>');
            stemmed.push(stem);
            results.push(stem);
          } else {
            stopped.push(wordlist[ix]);
          }

        }
        break;

      }	
	} else {
		dosearch = false;
	}

}

function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}